import type { ReactNode } from 'react'
import { Info } from 'lucide-react'
import { AntetFix } from './AntetFix'
import { Explicatie } from './Explicatie'

/**
 * Antetul oricarei pagini: titlu, o propozitie despre ce e pagina, actiunile principale in
 * dreapta, filtrele dedesubt. Acelasi loc pe toate ecranele, ca ochiul sa nu caute.
 *
 * Explicatiile lungi („de unde vin datele") nu stau ca paragraf deasupra tabelului: merg in
 * `explicatie`, la hover pe iconita de langa titlu.
 */
export function AntetPagina({
  titlu,
  descriere,
  explicatie,
  actiuni,
  children,
  fix = false,
}: {
  titlu: ReactNode
  /** O singura propozitie. */
  descriere?: ReactNode
  explicatie?: ReactNode
  /** Butoanele principale; actiunile rare intra intr-un meniu „Mai multe". */
  actiuni?: ReactNode
  /** Filtre, chip-uri, cautare — sub titlu. */
  children?: ReactNode
  /** Ramane pe ecran la derulare (vezi `AntetFix`). */
  fix?: boolean
}) {
  const continut = (
    <div className="grid gap-3">
      <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
        <div className="min-w-0">
          <h1 className="flex items-center gap-2 text-titlu text-b4l-text">
            {titlu}
            {explicatie && (
              <Explicatie text={explicatie} subliniat={false}>
                <Info size={16} className="text-b4l-text-dim" aria-label="Despre pagină" />
              </Explicatie>
            )}
          </h1>
          {descriere && <p className="mt-0.5 text-corp text-b4l-text-muted">{descriere}</p>}
        </div>
        {actiuni && <div className="flex flex-wrap items-center gap-2">{actiuni}</div>}
      </div>
      {children}
    </div>
  )
  return fix ? <AntetFix>{continut}</AntetFix> : <div className="mb-4">{continut}</div>
}
